// export const SERVER_URL = "http://localhost:8000/";
export const SERVER_URL = "http://torolaj.cluster028.hosting.ovh.net/quiz/public/";
export const API_URL = `${SERVER_URL}api/`;
